import * as React from 'react';
import * as style from './style.css';
import { UIText2, UIHeading2 } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var OffersCard = function OffersCard(_ref) {
  var offersUrl = _ref.offersUrl,
    offersCount = _ref.offersCount,
    trackClick = _ref.trackClick;
  return /*#__PURE__*/_jsxs("a", {
    href: offersUrl,
    target: "_blank",
    className: style['card'],
    rel: "noreferrer",
    onClick: trackClick,
    children: [/*#__PURE__*/_jsx(UIHeading2, {
      color: "primary_100",
      children: offersCount
    }), /*#__PURE__*/_jsxs(UIText2, {
      children: ["\u0412\u0441\u0435 \u0442\u0430\u043A\u0438\u0435 ", /*#__PURE__*/_jsx("br", {}), "\u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B"]
    })]
  });
};